const sortKeys = ['type', 'name', 'quantity', 'quality'] as const;

import { ItemType } from '@game/enums';
import type { ClientInventoryItem } from '@game/shared-types';

import type { InventoryState } from '../types/inventory.types';

export function getSortedInventory(inventory: ClientInventoryItem[], sortState: InventoryState): ClientInventoryItem[] {
  const sortedInventory = inventory;
  const comparisonFunctions: ((a: ClientInventoryItem, b: ClientInventoryItem) => number)[] = [];

  for (const key of sortKeys) {
    if (key === 'name' && sortState.sort[key] === 'up') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return a.item.name.localeCompare(b.item.name);
      });
    }
    if (key === 'name' && sortState.sort[key] === 'down') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return b.item.name.localeCompare(a.item.name);
      });
    }
    if (key === 'type' && sortState.sort[key] === 'up') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return ItemType[a.item.type].localeCompare(ItemType[b.item.type]);
      });
    }
    if (key === 'type' && sortState.sort[key] === 'down') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return ItemType[b.item.type].localeCompare(ItemType[a.item.type]);
      });
    }
    if ((key === 'quantity' || key === 'quality') && sortState.sort[key] === 'up') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return a[key] - b[key];
      });
    }
    if ((key === 'quantity' || key === 'quality') && sortState.sort[key] === 'down') {
      comparisonFunctions.push((a: ClientInventoryItem, b: ClientInventoryItem) => {
        return b[key] - a[key];
      });
    }
  }

  if (comparisonFunctions.length > 0) {
    for (const comparisonFunction of comparisonFunctions.toReversed()) {
      sortedInventory.sort(comparisonFunction);
    }
  }

  return sortedInventory;
}
